import React from 'react';

const AutoPlayInfoIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="Icon_Information">
                <path
                    d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 1.2C5.13989 1.2 1.2 5.13989 1.2 10C1.2 14.8601 5.13989 18.8 10 18.8C14.8601 18.8 18.8 14.8601 18.8 10C18.8 5.13989 14.8601 1.2 10 1.2Z"
                    id="Oval"
                    fill="#000000"
                    stroke="none"
                />
                <g id="Group-2" transform="translate(9 5)">
                    <path
                        d="M0.999 0L1.001 0Q1.09939 0 1.1959 0.0191955Q1.2924 0.038391 1.3833 0.0760443Q1.4742 0.113698 1.55601 0.168362Q1.63783 0.223026 1.7074 0.2926Q1.77697 0.362175 1.83164 0.443985Q1.8863 0.525796 1.92396 0.616699Q1.96161 0.707602 1.9808 0.804105Q2 0.900607 2 0.999L2 1.001Q2 1.09939 1.9808 1.1959Q1.96161 1.2924 1.92396 1.3833Q1.8863 1.4742 1.83164 1.55601Q1.77697 1.63783 1.7074 1.7074Q1.63783 1.77697 1.55601 1.83164Q1.4742 1.8863 1.3833 1.92396Q1.2924 1.96161 1.1959 1.9808Q1.09939 2 1.001 2L0.999 2Q0.900607 2 0.804105 1.9808Q0.707602 1.96161 0.616699 1.92396Q0.525796 1.8863 0.443985 1.83164Q0.362175 1.77697 0.2926 1.7074Q0.223026 1.63783 0.168362 1.55601Q0.113698 1.4742 0.0760443 1.3833Q0.038391 1.2924 0.0191955 1.1959Q0 1.09939 0 1.001L0 0.999Q0 0.900607 0.0191955 0.804105Q0.038391 0.707602 0.0760443 0.616699Q0.113698 0.525796 0.168362 0.443985Q0.223026 0.362175 0.2926 0.2926Q0.362175 0.223026 0.443985 0.168362Q0.525796 0.113698 0.616699 0.0760443Q0.707602 0.038391 0.804105 0.0191955Q0.900607 0 0.999 0Z"
                        id="i"
                        fill="#000000"
                        fillRule="evenodd"
                        stroke="none"
                    />
                    <path
                        d="M1.7 0L1.7 7L0 7L0 0L1.7 0Z"
                        transform="translate(0.13601074 3.192)"
                        id="Path-2"
                        fill="#000000"
                        fillRule="evenodd"
                        stroke="none"
                    />
                </g>
            </g>
        </svg>
    );
};

export default AutoPlayInfoIcon;
